import {
  CatalogImportApi,
  CatalogImportClient,
} from '@backstage/plugin-catalog-import';
import { serverErrorMessage } from '../lib/errors';

/**
 * The import stepper renders `error.message`, which for a failed request is
 * only the HTTP status line. Fold the server's explanation into it so the steps
 * we do not render ourselves still say why an import was rejected.
 */
function withErrorDetails(error: unknown): unknown {
  const detail = serverErrorMessage(error);

  if (error instanceof Error && detail) {
    error.message = `${error.message}: ${detail}`;
  }

  return error;
}

export class CatalogImportApiWithErrorDetails implements CatalogImportApi {
  constructor(private readonly delegate: CatalogImportClient) {}

  async analyzeUrl(url: string) {
    try {
      return await this.delegate.analyzeUrl(url);
    } catch (error) {
      throw withErrorDetails(error);
    }
  }

  async preparePullRequest() {
    try {
      return await this.delegate.preparePullRequest();
    } catch (error) {
      throw withErrorDetails(error);
    }
  }

  async submitPullRequest(options: {
    repositoryUrl: string;
    fileContent: string;
    title: string;
    body: string;
  }) {
    try {
      return await this.delegate.submitPullRequest(options);
    } catch (error) {
      throw withErrorDetails(error);
    }
  }
}
